/** 模型工具常量/函数（从 ModelSelector 拆出——react-refresh 要求组件文件只导出组件） */

/** 平台模型 id 前缀：value 为 platform:{model_id} 时聊天走云端转发（云端按量扣费） */
export const PLATFORM_PREFIX = 'platform:';
export const isPlatformModel = (id?: string) => !!id && id.startsWith(PLATFORM_PREFIX);

// 推理档/强制思考模型（与后端 graphify_service.REASONING_MODEL_PATTERNS 同口径）：
// 配速 3-10 倍超标，批量图谱构建必撞总时限——excludeReasoning 开启时从选项里滤掉
export const REASONING_MODEL_PATTERNS = ['glm-5.3-flash', 'glm-5.2', 'reasoner', '-o1', '-o3', '-o4'];
export const isReasoningModel = (id: string): boolean => {
  const m = (id || '').toLowerCase();
  return REASONING_MODEL_PATTERNS.some((p) => m.includes(p));
};
